// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/menu/menu-trigger/menu-trigger-icon-button.component.scss
// module id = 219
// module chunks = 0